import React from 'react';
import type { MultimediaResources } from 'Components/widgets/multimedia/Multimedia';
import 'Components/widgets/multimedia/Multimedia';
import { addTranslationKeys, t } from 'Src/i18n';
import { ProductImmersive } from 'Components/widgets/product-immersive/ProductImmersive';
type Props = {
  config: CMSContent;
  cruise: {
    fromToDestination: string;
  };
  id?: string;
  media: MultimediaResources;
  resort: Product;
};
export const ProductImmersiveLine = ({ config, id, media, resort }: Props) => {
  if (!resort) {
    return null;
  }

  const { images = [], name } = resort;
  addTranslationKeys(config);
  const galleryLabel = name
    ? t('common.galleries.productGallery', {
        productName: name,
      })
    : t('common.galleries.gallery');
  const nextLabel = name
    ? t('common.galleries.productNextPicture', {
        productName: name,
      })
    : t('common.next');
  const previousLabel = name
    ? t('common.galleries.productPreviousPicture', {
        productName: name,
      })
    : t('common.previous');
  const pictureAltLabel = t('common.galleries.productPictureItem', {
    total: images.length,
    productName: name,
  });
  return (
    <ProductImmersive
      className="Line Line-Immersive"
      closeLabel={t('common.close')}
      galleryLabel={galleryLabel}
      id={id}
      key={resort.id}
      media={images}
      multimedia={media}
      multimediaLabels={{
        photos: t('common.photoTitle'),
        videos: t('common.videoTitle'),
        videos360: t('common.video360Title'),
      }}
      nextLabel={nextLabel}
      openGalleryLabel={t('common.galleries.openSlideShowGallery')}
      pictureAltLabel={pictureAltLabel}
      previousLabel={previousLabel}
    />
  );
};
